// getLeaderboardUserCardsLayout.js
import { resourceLog } from '../resource/debug.js';
import {
  MAXIMUM_USER_CARD_AMOUNT_PER_ROW,
  USER_CARD_WIDTH,
  USER_CARD_HORIZONTAL_GAP,
  USER_CARDS_CONTAINER_HORIZONTAL_GAP,
} from '../resource/leaderboardConstants.js';

const isClient = typeof window !== 'undefined';

/**
 * @typedef {object} Layout
 * @property {number} amountPerRow - return user card amount per row
 * @property {boolean} isCentered - return true when can put more than MAXIMUM_USER_CARD_AMOUNT_PER_ROW in single row
 */

/**
 * get leaderboard user card layout
 *
 * @return {Layout}
 */
export const getLeaderboardUserCardsLayout = () => {
  try {
    let amountPerRow = 0;
    let isCentered = false;

    if (isClient) {
      const { width: screenWidth } = document.body.getBoundingClientRect();
      // if screen width is 0, then container width should be 0 too.
      const containerWidth = Math.max(
        screenWidth - USER_CARDS_CONTAINER_HORIZONTAL_GAP * 2,
        0
      );
      // amount formula:
      // container width = user card width * amount + (amount - 1) * user card gap
      const amount = Math.floor(
        (containerWidth + USER_CARD_HORIZONTAL_GAP) /
          (USER_CARD_WIDTH + USER_CARD_HORIZONTAL_GAP)
      );

      amountPerRow = Math.min(amount, MAXIMUM_USER_CARD_AMOUNT_PER_ROW);

      if (amount >= MAXIMUM_USER_CARD_AMOUNT_PER_ROW) {
        isCentered = true;
      }
    }

    return {
      amountPerRow,
      isCentered,
    };
  } catch (error) {
    resourceLog(
      'error occur when execute getAmountPerRow at resource/getLeaderboardUserCardsLayout.js',
      error
    );
  }
};

export default getLeaderboardUserCardsLayout;
